<div id="ac-panel-1bar-1" *ngIf="aggregatorMonth">
  <p data-cy="evolutionChartLegendTitle">
    <strong>{{ getMonthLabel(aggregatorMonth.monthDate) }}</strong>
  </p>
  <div
    class="rs-flex-row"
    *ngFor="let document of aggregatorMonth.positiveDocuments.documents"
  >
    <div class="rs-flex-column rs-flex-shrink">
      <div class="rs-barchart-legend rs-barchart-color-blue">
        <span class="show-for-sr">{{
          'bills.evolutionChart.web.positiveAmountColorLabel' | translate
        }}</span>
      </div>
    </div>
    <div class="rs-flex-column">
      <p>
        <span class="rs-font-pxB" data-cy="legendPaymentType">{{
          getDocumentTypeLabel(document.type)
        }}</span
        ><br />
        {{ document.reference }}
      </p>
    </div>
    <div class="rs-flex-column rs-flex-shrink" data-cy="legendAmount">
      <p class="rs-font-pxB">
        <px-currency-amount [amount]="document.amount"></px-currency-amount>
      </p>
    </div>
  </div>

  <div
    class="rs-flex-row"
    *ngFor="let document of aggregatorMonth.negativeDocuments.documents"
  >
    <div class="rs-flex-column rs-flex-shrink">
      <div class="rs-barchart-legend rs-barchart-color-magenta">
        <span class="show-for-sr">{{
          'bills.evolutionChart.web.negativeAmountColorLabel' | translate
        }}</span>
      </div>
    </div>
    <div class="rs-flex-column">
      <p>
        <span class="rs-font-pxB" data-cy="negativeLegendPaymentType">{{
          getDocumentTypeLabel(document.type)
        }}</span
        ><br />
        {{ document.reference }}
      </p>
    </div>
    <div class="rs-flex-column rs-flex-shrink" data-cy="negativeLegendAmount">
      <p class="rs-font-pxB">
        <px-currency-amount [amount]="document.amount"></px-currency-amount>
      </p>
    </div>
  </div>
</div>
